import '../../utils/assertions.es.js';
import 'react';
import '../../utils/responsive.es.js';
import '../../utils/scrollIntoView.es.js';
import { radius, palette, spacing } from '../../utils/theme.es.js';
import '../../utils/useEnhancedEffect.es.js';
import 'react-is';
import styled from 'styled-components';

const FloatingActionMenu = styled.div`
    display: inline-flex;
    align-items: center;
    height: 60px;
    border-radius: ${radius("round")};
    background-color: ${palette("surface")};
    padding: 0 ${spacing("sm")};
    color: ${palette("neutral.900")};
`;

export { FloatingActionMenu };
//# sourceMappingURL=styled.es.js.map
